import { useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import { useStudentReportUIContext } from "../StudentReportUIContext";

export function FilterButtonsTable() {
  // Student Report UI Context
  const studentReportUIContext = useStudentReportUIContext();
  const studentReportUIProps = useMemo(() => {
    return {
      columns: studentReportUIContext.columns,
      setColumns: studentReportUIContext.setColumns
    };
  }, [studentReportUIContext]);
  
  const [photoStyle, setPhotoStyle] = useState("light");
  const [studentNumberStyle, setStudentNumberStyle] = useState("light");
  const [tcKimlikNoStyle, setTcKimlikNoStyleStyle] = useState("light");
  const [nameStyle, setNameStyle] = useState("light");
  const [surnameStyle, setSurnameStyle] = useState("light");
  const [sexNameStyle, setSexNameStyle] = useState("light");
  const [gradeLevelNameStyle, setGradeLevelNameStyle] = useState("light");
  const [sectionStyle, setSectionStyle] = useState("light");
  const [phoneStyle, setPhoneStyle] = useState("light");
  const [emailStyle, setEmailStyle] = useState("success");
  const [birthDateStyle, setBirthDateStyle] = useState("success");
  const [registrationStatusNameStyle, setRegistrationStatusNameStyle] = useState("success");
  const [registrationNoStyle, setRegistrationNoStyle] = useState("success");
  const [registrationDateStyle, setRegistrationDateStyle] = useState("success");
  const [theSchoolWhereComeFromStyle, setTheSchoolWhereComeFromStyle] = useState("success");
  const [willUseCafeteriaStyle, setWillUseCafeteriaStyle] = useState("success");
  const [transportationUsageNameStyle, setTransportationUsageNameStyle] = useState("success");
  const [advisorsStyle, setAdvisorsStyle] = useState("success");
  const [fatherTcKimlikNoStyle, setFatherTcKimlikNoStyle] = useState("success");
  const [fatherNameStyle, setFatherNameStyle] = useState("success");
  const [fatherOccupationStyle, setFatherOccupationStyle] = useState("success");
  const [fatherOccupationCategoryStyle, setFatherOccupationCategoryStyle] = useState("success");
  const [fatherAddressStyle, setFatherAddressStyle] = useState("success");
  const [fatherPhoneStyle, setFatherPhoneStyle] = useState("success");
  const [fatherEmailStyle, setFatherEmailStyle] = useState("success");
  const [motherTcKimlikNoStyle, setMotherTcKimlikNoStyle] = useState("success");
  const [motherNameStyle, setMotherNameStyle] = useState("success"); 
  const [motherOccupationStyle, setMotherOccupationStyle] = useState("success");
  const [motherOccupationCategoryStyle, setMotherOccupationCategoryStyle] = useState("success"); 
  const [motherPhoneStyle, setMotherPhoneStyle] = useState("success");
  const [motherEmailStyle, setMotherEmailStyle] = useState("success");
  const [parentRelationshipStyle, setParentRelationshipStyle] = useState("success");
  const [otherTcKimlikNoStyle, setOtherTcKimlikNoStyle] = useState("success");
  const [otherNameStyle, setOtherNameStyle] = useState("success"); 
  const [otherOccupationStyle, setOtherOccupationStyle] = useState("success");
  const [otherOccupationCategoryStyle, setOtherOccupationCategoryStyle] = useState("success"); 
  const [otherPhoneStyle, setOtherPhoneStyle] = useState("success");
  const [otherEmailStyle, setOtherEmailStyle] = useState("success");
  const [uniformInfoStyle, setUniformInfoStyle] = useState("success");
  const [uniformExplanationStyle, setUniformExplanationStyle] = useState("success");
  const [bookInfoStyle, setBookInfoStyle] = useState("success");
  const [bookExplanationStyle, setBookExplanationStyle] = useState("success");
  const [registrationNoteStyle, setRegistrationNoteStyle] = useState("success");
  
  /** */
  const setButtonStyle = (dataField) => {
    if (dataField === "photoStr") return setPhotoStyle;
    else if (dataField === "studentNumber") return setStudentNumberStyle;
    else if (dataField === "studentNumber") return setStudentNumberStyle;
    else if (dataField === "identityCard.tcKimlikNo") return setTcKimlikNoStyleStyle;
    else if (dataField === "identityCard.name") return setNameStyle;
    else if (dataField === "identityCard.surname") return setSurnameStyle;
    else if (dataField === "sexName") return setSexNameStyle;
    else if (dataField === "gradeLevelName") return setGradeLevelNameStyle;
    else if (dataField === "section") return setSectionStyle;
    else if (dataField === "phone") return setPhoneStyle;
    else if (dataField === "email") return setEmailStyle;
    else if (dataField === "identityCard.birthDate") return setBirthDateStyle;
    else if (dataField === "registrationInfo.registrationStatusName") return setRegistrationStatusNameStyle;
    else if (dataField === "registrationNo") return setRegistrationNoStyle;
    else if (dataField === "registrationDate") return setRegistrationDateStyle;
    else if (dataField === "theSchoolWhereComeFrom") return setTheSchoolWhereComeFromStyle;
    else if (dataField === "registrationInfo.willUseCafeteria") return setWillUseCafeteriaStyle;
    else if (dataField === "registrationInfo.transportationUsageName") return setTransportationUsageNameStyle;
    else if (dataField === "advisors") return setAdvisorsStyle;
    else if (dataField === "father.tcKimlikNo") return setFatherTcKimlikNoStyle;
    else if (dataField === "father.name") return setFatherNameStyle;
    else if (dataField === "father.occupation") return setFatherOccupationStyle;
    else if (dataField === "father.occupationCategoryName") return setFatherOccupationCategoryStyle;
    else if (dataField === "father.workAddress.address1") return setFatherAddressStyle;
    else if (dataField === "father.phone1") return setFatherPhoneStyle;
    else if (dataField === "father.email") return setFatherEmailStyle;
    else if (dataField === "mother.tcKimlikNo") return setMotherTcKimlikNoStyle;
    else if (dataField === "mother.name") return setMotherNameStyle;
    else if (dataField === "mother.occupation") return setMotherOccupationStyle;
    else if (dataField === "mother.occupationCategoryName") return setMotherOccupationCategoryStyle;
    else if (dataField === "mother.phone1") return setMotherPhoneStyle;
    else if (dataField === "mother.email") return setMotherEmailStyle;
    else if (dataField === "parentRelationship") return setParentRelationshipStyle;
    else if (dataField === "other.tcKimlikNo") return setOtherTcKimlikNoStyle;
    else if (dataField === "other.name") return setOtherNameStyle;
    else if (dataField === "other.occupation") return setOtherOccupationStyle;
    else if (dataField === "other.occupationCategoryName") return setOtherOccupationCategoryStyle;
    else if (dataField === "other.phone1") return setOtherPhoneStyle;
    else if (dataField === "other.email") return setOtherEmailStyle;
    else if (dataField === "registrationInfo.bougthUniform") return setUniformInfoStyle;
    else if (dataField === "registrationInfo.uniformExplanation") return setUniformExplanationStyle;
    else if (dataField === "registrationInfo.bougthBook") return setBookInfoStyle;
    else if (dataField === "registrationInfo.bookExplanation") return setBookExplanationStyle;
    else if (dataField === "registrationInfo.registrationNote") return setRegistrationNoteStyle;
  }

  /** */
  const toggleHidden = (dataField) => {
    const newColumns = [];

    studentReportUIProps.columns.forEach(column => {
      const newColumn = {
        dataField: column.dataField,
        text: column.text,
        sort: column.sort,
        width: column.width,
        hidden: column.hidden,
        sortCaret: column.sortCaret,
        formatter: column.formatter,
        style: column.style
      };

      if (column.dataField === dataField) {
        newColumn.hidden = !column.hidden;
        setButtonStyle(dataField)(newColumn.hidden ? "success" : "light");
      }

      newColumns.push(newColumn);
    });    

    studentReportUIProps.setColumns(newColumns);
  }  
  
  return (
    <div className="mt-5">
      <h5 className="card-label">Filtrele</h5>
      <Table hover>
        <tbody>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${photoStyle}`}
                onClick={() => toggleHidden("photoStr")}
              >
                Fotoğraf
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${studentNumberStyle}`}
                onClick={() => toggleHidden("studentNumber")}
              >
                Öğrenci Numarası
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${tcKimlikNoStyle}`}
                onClick={() => toggleHidden("identityCard.tcKimlikNo")}
              >
                TC Kimlik No
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${nameStyle}`}
                onClick={() => toggleHidden("identityCard.name")}
              >
                Adı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${surnameStyle}`}
                onClick={() => toggleHidden("identityCard.surname")}
              >
                Soyadı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${sexNameStyle}`}
                onClick={() => toggleHidden("sexName")}
              >
                Cinsiyeti
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${gradeLevelNameStyle}`}
                onClick={() => toggleHidden("gradeLevelName")}
              >
                Sınıf Düzeyi
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${sectionStyle}`}
                onClick={() => toggleHidden("section")}
              >
                Şube
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${phoneStyle}`}
                onClick={() => toggleHidden("phone")}
              >
                Telefon
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${emailStyle}`}
                onClick={() => toggleHidden("email")}
              >
                Email
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${birthDateStyle}`}
                onClick={() => toggleHidden("identityCard.birthDate")}
              >
                Doğum Tarihi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${registrationStatusNameStyle}`}
                onClick={() => toggleHidden("registrationInfo.registrationStatusName")}
              >
                Kayıt Durumu
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${registrationNoStyle}`}
                onClick={() => toggleHidden("registrationNo")}
              >
                Kayıt Sıra No
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${registrationDateStyle}`}
                onClick={() => toggleHidden("registrationDate")}
              >
                Kayıt Tarihi
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${theSchoolWhereComeFromStyle}`}
                onClick={() => toggleHidden("theSchoolWhereComeFrom")}
              >
                Geldiği Okul
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${willUseCafeteriaStyle}`}
                onClick={() => toggleHidden("registrationInfo.willUseCafeteria")}
              >
                Yemekhane
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${transportationUsageNameStyle}`}
                onClick={() => toggleHidden("registrationInfo.transportationUsageName")}
              >
                Servis Bilgileri
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${advisorsStyle}`}
                onClick={() => toggleHidden("advisors")}
              >
                Danışman Öğretmenler
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${fatherTcKimlikNoStyle}`}
                onClick={() => toggleHidden("father.tcKimlikNo")}
              >
                Baba TC Kimlik No
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${fatherNameStyle}`}
                onClick={() => toggleHidden("father.name")}
              >
                Baba Adı Soyadı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${fatherOccupationStyle}`}
                onClick={() => toggleHidden("father.occupation")}
              >
                Baba Mesleği
              </button>
            </td>            
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${fatherOccupationCategoryStyle}`}
                onClick={() => toggleHidden("father.occupationCategoryName")}
              >
                Baba Meslek Kategorisi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${fatherAddressStyle}`}
                onClick={() => toggleHidden("father.workAddress.address1")}
              >
                Baba İş Adresi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${fatherPhoneStyle}`}
                onClick={() => toggleHidden("father.phone1")}
              >
                Baba Telefon
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${fatherEmailStyle}`}
                onClick={() => toggleHidden("father.email")}
              >
                Baba Email
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${motherTcKimlikNoStyle}`}
                onClick={() => toggleHidden("mother.tcKimlikNo")}
              >
                Anne TC Kimlik No
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${motherNameStyle}`}
                onClick={() => toggleHidden("mother.name")}
              >
                Anne Adı Soyadı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${motherOccupationStyle}`}
                onClick={() => toggleHidden("mother.occupation")}
              >
                Anne Mesleği
              </button>
            </td>            
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${motherOccupationCategoryStyle}`}
                onClick={() => toggleHidden("mother.occupationCategoryName")}
              >
                Anne Meslek Kategorisi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${motherPhoneStyle}`}
                onClick={() => toggleHidden("mother.phone1")}
              >
                Anne Telefonu
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${motherEmailStyle}`}
                onClick={() => toggleHidden("mother.email")}
              >
                Anne Email
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${parentRelationshipStyle}`}
                onClick={() => toggleHidden("parentRelationship")}
              >
                Veli Yakınlığı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${otherTcKimlikNoStyle}`}
                onClick={() => toggleHidden("other.tcKimlikNo")}
              >
                Veli TC Kimlik No
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${otherNameStyle}`}
                onClick={() => toggleHidden("other.name")}
              >
                Veli Adı Soyadı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${otherOccupationStyle}`}
                onClick={() => toggleHidden("other.occupation")}
              >
                Veli Mesleği
              </button>
            </td>
          </tr>
          <tr>
             <td>
              <button
                type="button"
                className={`btn btn-sm btn-${otherOccupationCategoryStyle}`}
                onClick={() => toggleHidden("other.occupationCategoryName")}
              >
                Veli Meslek Kategorisi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${otherPhoneStyle}`}
                onClick={() => toggleHidden("other.phone1")}
              >
                Veli Telefonu
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${otherEmailStyle}`}
                onClick={() => toggleHidden("other.email")}
              >
                Veli Email
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${uniformInfoStyle}`}
                onClick={() => toggleHidden("registrationInfo.bougthUniform")}
              >
                Kıyafet Bilgileri
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${uniformExplanationStyle}`}
                onClick={() => toggleHidden("registrationInfo.uniformExplanation")}
              >
                Kıyafet Açıklama
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${bookInfoStyle}`}
                onClick={() => toggleHidden("registrationInfo.bougthBook")}
              >
                Kitap Durumu
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${bookExplanationStyle}`}
                onClick={() => toggleHidden("registrationInfo.bookExplanation")}
              >
                Kitap Açıklama
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${registrationNoteStyle}`}
                onClick={() => toggleHidden("registrationInfo.registrationNote")}
              >
                Öğrenci Açıklama
              </button>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}